import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryHighVoltageIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M0.254883 16.0808H17.1461V4.12638H13.6373V1.98438H11.1281V4.12638H6.27288V1.98438H3.76368V4.12638H0.254883V16.0808ZM15.3509 5.92158V14.2856H2.05008V5.92158H15.3509ZM8.23128 13.4492L11.7401 9.40998H9.06768L10.2917 6.88038H9.16968L5.66088 10.9196H8.33328L7.10928 13.4492H8.23128ZM18.8415 17.0703V8.00977H20.6415V18.8703H4.7998V17.0703H18.8415ZM21.9621 20.31V12.8096H23.7621V22.11H9.6001V20.31H21.9621Z"
      />
    </SvgIcon>
  );
});
